import template from './multiLoanCpaModal.html';
import controller from './multiLoanCpaModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    clientHeaderName: '<',
  },
};
